import { Component } from '@angular/core'
import {
  AnonymousConsentsConfig,
  AnonymousConsentsService,
  AuthService,
  GlobalMessageService,
  UserConsentService
} from '@spartacus/core'
import { ConsentManagementComponent } from '@spartacus/storefront'

@Component({
    selector: 'eb-consent-management',
    templateUrl: './eb-consent-management.component.html',
    styleUrls: ['./eb-consent-management.component.scss'],
    standalone: false
})
export class EbConsentManagementComponent extends ConsentManagementComponent {
  constructor(
    protected userConsentService: UserConsentService,
    protected globalMessageService: GlobalMessageService,
    protected anonymousConsentsConfig: AnonymousConsentsConfig,
    protected anonymousConsentsService: AnonymousConsentsService,
    protected authService: AuthService
  ) {
    super(
      userConsentService,
      globalMessageService,
      anonymousConsentsConfig,
      anonymousConsentsService,
      authService
    )
  }

  ngOnInit(): void {
    super.ngOnInit()
  }
}
